import { IDispense, DispenseOrderStatus } from "../@types/dispense";
import { ITill, TillOrderStatus } from "../@types/till";
import { AuthUserType } from "../auth/types";

export class MockDataService {
  static getMockDispenseData(user: AuthUserType): IDispense[] {
    return [
      {
        id: 1,
        dispense: "Mock Dispense 1",
        name:
          [user?.firstName, user?.lastName].filter(Boolean).join(" ") ||
          "John Doe",
        email: user?.email || "patient@example.com",
        status: DispenseOrderStatus.OUTSTANDING,
        number: 12345,
        orderId: 1001,
        phone: parseInt(user?.phone || "1234567890"),
        patientId: parseInt(user?.id || "1"),
        isExternal: false,
        voucherId: 1,
        addonId: 1,
        orderingNotes: "Mock dispense data for patient user",
        totalPrice: 389.98,
        patient: {
          id: user?.id || "1",
          firstName: user?.firstName || "John",
          lastName: user?.lastName || "Doe",
          surName: user?.lastName || "Doe",
          date_of_birth: new Date("1990-01-01"),
          gp: "Dr. General",
          gpDetails: {
            name: "Dr. General",
            address:
              "London Medical Centre\n123 Healthcare Street\nLondon, SW1A 1AA",
          },
          gender: "Other",
          email: user?.email || "patient@example.com",
          phone: user?.phone || "1234567890",
          mobile: user?.phone || "1234567890",
          landline: "0207123456",
          postCode: "SW1A 1AA",
          town: "London",
          county: "Greater London",
          houseNumber: "123",
          street: "Main Street",
          address: "123 Main Street, London, Greater London",
          age: 33,
          consentSMS: false,
          consentEmail: false,
          consentPhone: false,
          consentPost: false,
          nhsEyeTestEligibility: {
            under16: false,
            over60: true,
            student: false,
            benefits: false,
            glaucomaDiabetes: false,
            familyHistory: false,
            other: false,
            otherDetails: "",
            evidenceSeen: true,
            auditLog: [
              {
                field: "over60",
                value: true,
                timestamp: "2024-01-15T09:00:00Z",
                staffUserId: "staff-001",
              },
              {
                field: "evidenceSeen",
                value: true,
                timestamp: "2024-01-15T09:00:00Z",
                staffUserId: "staff-001",
              },
            ],
          },
          communicationStyle: {
            method: "Email",
            customText: "",
          },
          isActive: true,
        },
      },
      {
        id: 2,
        dispense: "Mock Dispense 2",
        name:
          [user?.firstName, user?.lastName].filter(Boolean).join(" ") ||
          "John Doe",
        email: user?.email || "patient@example.com",
        status: DispenseOrderStatus.UNPROCESSED,
        number: 12346,
        orderId: 1002,
        phone: parseInt(user?.phone || "1234567890"),
        patientId: parseInt(user?.id || "1"),
        isExternal: false,
        voucherId: 2,
        addonId: 2,
        orderingNotes: "Previous mock dispense data",
        totalPrice: 149.99,
        patient: {
          id: user?.id || "1",
          firstName: user?.firstName || "John",
          lastName: user?.lastName || "Doe",
          surName: user?.lastName || "Doe",
          date_of_birth: new Date("1990-01-01"),
          gp: "Dr. General",
          gpDetails: {
            name: "Dr. General",
            address:
              "City Health Practice\n456 Medical Avenue\nLondon, SW2B 2BB",
          },
          gender: "Other",
          email: user?.email || "patient@example.com",
          phone: user?.phone || "1234567890",
          mobile: user?.phone || "1234567890",
          landline: "0207123456",
          postCode: "SW1A 1AA",
          town: "London",
          county: "Greater London",
          houseNumber: "123",
          street: "Main Street",
          address: "123 Main Street, London, Greater London",
          age: 33,
          consentSMS: false,
          consentEmail: false,
          consentPhone: false,
          consentPost: false,
          nhsEyeTestEligibility: {
            under16: false,
            over60: false,
            student: true,
            benefits: false,
            glaucomaDiabetes: false,
            familyHistory: false,
            other: false,
            otherDetails: "",
            evidenceSeen: true,
            auditLog: [
              {
                field: "student",
                value: true,
                timestamp: "2024-01-10T14:00:00Z",
                staffUserId: "staff-002",
              },
              {
                field: "evidenceSeen",
                value: true,
                timestamp: "2024-01-10T14:00:00Z",
                staffUserId: "staff-002",
              },
            ],
          },
          communicationStyle: {
            method: "Custom",
            customText: "Please contact via WhatsApp during weekdays only",
          },
          isActive: true,
        },
      },
    ];
  }

  static getMockTillData(user: AuthUserType): ITill[] {
    return [
      {
        id: 1,
        name:
          [user?.firstName, user?.lastName].filter(Boolean).join(" ") ||
          "John Doe",
        postCode: "SW1A 1AA",
        phone: user?.phone || "1234567890",
        email: user?.email || "patient@example.com",
        date: new Date(),
        status: TillOrderStatus.PENDING,
        pickupDate: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000),
        pickupTime: "14:00",
      },
      {
        id: 2,
        name:
          [user?.firstName, user?.lastName].filter(Boolean).join(" ") ||
          "John Doe",
        postCode: "SW1A 1AA",
        phone: user?.phone || "1234567890",
        email: user?.email || "patient@example.com",
        date: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000),
        status: TillOrderStatus.PARTIAL,
        pickupDate: new Date(),
        pickupTime: "10:00",
      },
    ];
  }
}
